import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
 <footer className="w-full text-center py-4 bg-gray-50 text-gray-600 text-sm border-t border-gray-200">
    {/* Info Links Section */}

    <div className="mt-1 flex flex-col md:flex-row justify-center gap-6 text-sm text-gray-600">
      <Link to="/aboutus" className="hover:text-green-700">
        About Us
      </Link>
      <Link to="/contactus" className="hover:text-green-700">
        Contact Us
      </Link>
      <Link to="/terms" className="hover:text-green-700">
        Terms & Conditions
      </Link>
      <Link to="/faq" className="hover:text-green-700">
        FAQ
      </Link>
    </div>
    <p className="mt-2"> &copy; {new Date().getFullYear()} FamilyDuniya. All rights reserved.</p>
  </footer>
);
}